'use strict';

/* Slick Carousel */
import 'slick-carousel';

require('!style-loader!css!slick-carousel/slick/slick.css');

let prevArrow = '<button type="button" class="slick-prev" aria-label="Précédent"><i class="fa-regular fa-chevron-left"></i></button>';
let nextArrow = '<button type="button" class="slick-next" aria-label="Suivant"><i class="fa-regular fa-chevron-right"></i></button>';

// eslint-disable-next-line no-unused-vars
let breakpoints = {
    'sm': 575,
    'md': 767,
    'lg': 991,
    'xl': 1199,
    'xxl': 1549,
    '3xl': 1799,
};

(function ($) {
    $(window).on('load statechangecomplete', function () {

        $('.slick-gallery').each(function () {
            $(this).slick({
                rows: 0,
                arrows: true,
                appendArrows: $('.slick-nav-arrows', $(this).parent()),
                prevArrow: prevArrow,
                nextArrow: nextArrow,
                dots: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                swipeToSlide: true,
            });
        });

        $('.slider-logos.slider-ltr').each(function () {
            $(this).slick({
                rows: 0,
                arrows: false,
                dots: false,
                slidesToShow: 3,
                slidesToScroll: 1,
                swipeToSlide: true,
                infinite: true,
                vertical: true,
                autoplay: true,
                autoplaySpeed: 0,
                speed: 6000,
                cssEase: 'linear',
                pauseOnHover: true,
                responsive: [
                    {
                        breakpoint: 1350,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1,
                            vertical: false
                        }
                    }
                ]
            });
        });

        $('.slider-logos.slider-rtl').each(function () {
            $(this).slick({
                rows: 0,
                arrows: false,
                dots: false,
                slidesToShow: 3,
                slidesToScroll: -1,
                swipeToSlide: true,
                infinite: true,
                vertical: true,
                autoplay: true,
                autoplaySpeed: 0,
                pauseOnHover: true,
                speed: 6000,
                cssEase: 'linear',
                rtl: false,
                verticalReverse: true,
                responsive: [
                    {
                        breakpoint: 1350,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1,
                            vertical: false,
                            rtl:true,
                        }
                    }
                ]
            });
        });

    });
})(jQuery);


// WEBPACK FOOTER //
// ./scripts/slick-carousel.js